<template>
  <div class="content-container">
    <!--头部文字-->
    <div class="list-title">
      <el-page-header @back="$router.back()" content="BACnet数据查询配置"></el-page-header>
    </div>

    <!--项目编辑内容-->
    <div class="content-box">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px">
        <el-form-item label="服务类型">
          <span style="font-weight: bold;padding: 0 10px;">{{ ruleForm.type }}</span>
        </el-form-item>
        <el-form-item label="业务模板">
          <span style="font-weight: bold;padding: 0 10px;">{{ ruleForm.businessName }}</span>
        </el-form-item>
        <el-form-item label="服务名称" prop="name">
          <el-input v-model="ruleForm.name" style="width: 33%;min-width:350px;"></el-input>
        </el-form-item>

        <div class="form-link"></div>

        <el-form-item label="BACnet数据采集" prop="proid">
          <el-select v-model="ruleForm.proid" placeholder="请选择" style="width: 33%;min-width:350px;">
            <el-option
              v-for="item in bacnetList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="$router.back()">取消</el-button>
          <el-button type="primary" @click="onSubmit('ruleForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      bacnetList: [], //modbus列表
      ruleForm: {
        id: "",
        proType: "",
        type:"",
        name:"BACnet数据查询服务",
        business:"",
        businessName: "",
        proid: "",
      },
      rules:{
        name: [
          { required: true, message: '请输入服务名称', trigger: 'blur' }
        ],
        proid:[
          {required: true, message: '请选择BACnet数据采集服务', trigger: 'blur'}
        ]
      },
    };
  },
  methods: {
    onSubmit(formName){
      let _this = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          submit();
        } else {
          return false;
        }
      });
      function submit(){
        let formData = new FormData();
        formData.append("id", _this.ruleForm.id);
        formData.append("proType", _this.ruleForm.proType);
        formData.append("type", _this.ruleForm.type);
        formData.append("name", _this.ruleForm.name);
        formData.append("business", _this.ruleForm.business);
        formData.append("proid", _this.ruleForm.proid);
        var uid = getCookieV('userid1');
        var token = getCookieV('token1');
        _this.axios({
          method: 'post',
          url: _this.api.saveServerProject,
          data: formData,
          params: {
            uid: uid,
            tk: token,
          },
        }).then(function(res){
          console.log(res);
          let data=res.data;
          if(data.code==-1){
              window.location.href=_this.api.loginHtmlUrl;
          }else{
            _this.$message({
              message: '保存成功!',
              type: 'success'
            });
            _this.$router.push({name: 'list'});
          }
        }).catch(function(){
            commonErrorTip(_this);
        })
      }
    }
  },
  created() {
    
  },
  mounted() {
    let _this = this;
    _this.$store.state.mainLeftMenu=1;
    var uid = getCookieV('userid1');
    var token = getCookieV('token1');
    _this.axios({
      method: 'get',
      url: _this.api.selectBacnetServerProject,
      params: {
        uid: uid,
        tk: token,
      },
    }).then(res=>{
      let data = res.data;
      if(data.code==200){
        _this.bacnetList = data.data;
      }else if(data.code==-1){
        window.location.href=_this.api.loginHtmlUrl;
      }
    }).catch(function(){
      commonErrorTip(_this);
    })

    var query = _this.$route.query;
    if(query.id != null && !(query.id === undefined) && !(query.id === "")){
      _this.axios({
        method: 'get',
        url: _this.api.queryByIdServerProject+"/"+query.id,
        params: {
          uid: uid,
          tk: token,
        },
      }).then(res=>{
        let data = res.data;
        if(data.code==200){
          _this.ruleForm = data.data;
          _this.ruleForm.businessName = _this.$store.state.businessList[_this.ruleForm.business].name;
        }else if(data.code==-1){
            window.location.href=_this.api.loginHtmlUrl;
        }
      }).catch(function(){
          commonErrorTip(_this);
      })
    }else{
      _this.ruleForm.proType = query.proType;
      _this.ruleForm.type = query.type;
      _this.ruleForm.business = query.business;
      _this.ruleForm.businessName = _this.$store.state.businessList[_this.ruleForm.business].name;
    }
  },
  // watch: {
  //   ruleForm: {
  //     deep: true,
  //     handler: function(newV, oldV) {
  //       console.log('counter change to %o from %o', newV, oldV);
  //     }
  //   }
  // }
};
</script>
<style lang="scss" scoped>
.list-div {
  position: relative;
  padding: 0 0 0 30px;
  height: 850px;
  width: 90%;
  left: 80px;
}
.list-title {
  position: relative;
  // left: 15px;
  font-size: 20px;
  color: #333;
  padding: 10px;
  border-bottom: 1px solid #dadada;
}
.steps-div{
  height: 300px;
  width: 200px;
  // background-color: #ffffff;
}
.edit-div{
  height: 100%;
}

.form-link{
  width: 100%;
  border-bottom: 1px solid #dadada;
  margin-bottom: 22px;
  box-shadow: 0 0 2px 2px #efefef;
}

</style>